import axios from 'axios'
import api from '@/api'

const userAccount = {
  state: {
    data: {
      data: {
        permissions: {
          permissions: {
            home: 1,
            users: 1,
            offices: 1,
            institutions: 1,
            patients: 1,
            services: 1,
            holidays: 1,
            children_holidays: 1,
            categories: 1,
            system_sio_report: 1
          }
        }
      }
    }
  },
  getters: {
    getAccount: state => state.data.data,
    getAccountPermissions: state => state.data.data.permissions,
  },
  mutations: {
    USER_ACCOUNT_GET (state, payload) {
      state.data.data = payload
    },
  },
  actions: {
    userAccountGet (context) {
      axios({
        method: 'get',
        url: `${api}auth/me`
      }).then(response => {
        context.commit('USER_ACCOUNT_GET', response.data.data);
      }).catch((error) => {
        console.log(error);
      })
    }
  }
};
export default userAccount
